<div class="main-content">
  <div class="container">
    <div class="row mb-4">
      <!--TOTAL-->
      <!--<div class="col-12 col-md mb-2 mb-md-0">-->
      <!--<mat-card class="dashboard-panel h-100">-->
      <!--<mat-card-header *ngIf="!showLoadingData">-->
      <!--<mat-card-title>Total</mat-card-title>-->
      <!--</mat-card-header>-->
      <!--<mat-card-content class="text-center">-->
      <!--<div class="d-flex justify-content-center">-->
      <!--<mat-spinner *ngIf="showLoadingData" [color]="'primary'" [mode]="'indeterminate'"-->
      <!--[diameter]="'30'"></mat-spinner>-->
      <!--</div>-->
      <!--<h1 *ngIf="!showLoadingData">-->
      <!--{{data?.total?.impressions | number}}-->
      <!--</h1>-->
      <!--</mat-card-content>-->
      <!--</mat-card>-->
      <!--</div>-->

      <!--PENDING-->
      <div class="col-12 col-sm mb-2 mb-md-0">
        <mat-card class="dashboard-panel dashboard-panel--pending h-100">
          <mat-card-content class="">
            <div class="d-flex justify-content-center">
              <mat-spinner *ngIf="showLoadingData" [color]="'primary'" [mode]="'indeterminate'"
                           [diameter]="'30'"></mat-spinner>
            </div>
            <div class="dashboard-panel-content d-flex align-items-center" *ngIf="!showLoadingData">
              <h1 class="col justify-content-between">
                Pending
                <span>{{data?.numPending | number}}</span>
                <small>out of {{data?.numTotal}}</small>
              </h1>
              <div class="col d-sm-none d-md-inline dashboard-panel-chart">
                <cm-progress-circle [value]="data?._numPendingPct" [fill]="'orange'"></cm-progress-circle>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!--APPROVED-->
      <div class="col-12 col-sm  mb-2 mb-md-0">
        <mat-card class="dashboard-panel dashboard-panel--approved h-100">
          <mat-card-content class="">
            <div class="d-flex justify-content-center">
              <mat-spinner *ngIf="showLoadingData" [color]="'primary'" [mode]="'indeterminate'"
                           [diameter]="'30'"></mat-spinner>
            </div>
            <div class="dashboard-panel-content d-flex align-items-center" *ngIf="!showLoadingData">
              <h1 class="col justify-content-between">
                Approved
                <span>{{data?.numApproved | number}}</span>
                <small>out of {{data?.numTotal}}</small>
              </h1>
              <div class="col d-sm-none d-md-inline dashboard-panel-chart">
                <cm-progress-circle [value]="data?._numApprovedPct" [fill]="'green'"></cm-progress-circle>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!--REJECTED-->
      <div class="col-12 col-sm  mb-2 mb-md-0">
        <mat-card class="dashboard-panel dashboard-panel--rejected h-100">
          <mat-card-content class="">
            <div class="d-flex justify-content-center">
              <mat-spinner *ngIf="showLoadingData" [color]="'primary'" [mode]="'indeterminate'"
                           [diameter]="'30'"></mat-spinner>
            </div>
            <div class="dashboard-panel-content d-flex align-items-center" *ngIf="!showLoadingData">
              <h1 class="col justify-content-between">
                Rejected
                <span>{{data?.numRejected | number}}</span>
                <small>out of {{data?.numTotal}}</small>
              </h1>
              <div class="col d-sm-none d-md-inline dashboard-panel-chart">
                <cm-progress-circle [value]="data?._numRejectedPct" [fill]="'red'"></cm-progress-circle>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="container-fluid container-xxl container--big">
    <div class="row">
      <div class="col">
        <div class="cm-card">
          <div class="cm-card-header d-flex justify-content-between align-items-center" >
            
            <h3 class="cm-card-title" *ngIf="!selection.selected.length">Ad units</h3>

            <div class="mat-card-header-select-controls d-flex show-in-down" *ngIf="selection.selected.length" [hidden]="showLoadingData">
              <button mat-raised-button color="primary"
                      [disabled]="!selection.selected.length"
                      (click)="approveSelectedUnits()" class="d-none d-md-block mr-2">
                Approve units
              </button>
              <button mat-raised-button color="warn"
                      [disabled]="!selection.selected.length"
                      (click)="rejectSelectedUnits()" class="d-none d-md-block mr-2">
                Reject units
              </button>
              <button mat-raised-button color="success"
                      [disabled]="!selection.selected.length"
                      *ngIf="isUnitActivatedAllowed"
                      (click)="activateSelectedUnits()" class="d-none d-md-block">
                Activate units
              </button>
            </div>

            <div class="mat-card-header-controls d-flex align-items-center" [hidden]="showLoadingData">
              <button mat-raised-button color="primary"
                      (click)="updateUnits()"
                      class="d-none d-md-block mr-4">
                <i class="far fa-sync"></i>
                <span class="ml-2">Update units</span>
              </button>
              <button mat-icon-button color="primary"
                      matTooltip="Download CSV template"
                      *ngIf="!isUnitActivatedAllowed"
                      (click)="downloadCsvTemplate()"
                      class="d-none d-md-block mr-2">
                <i class="fas fa-cloud-download"></i>
              </button>
              <cm-custom-upload-button-icon
                matTooltip="Upload data"
                (fileSelected)="uploadFile($event)"
                class="d-none d-md-block mr-2">
              </cm-custom-upload-button-icon>
              <button mat-icon-button color="primary"
                      (click)="exportCsv()"
                      class="d-none d-md-block mr-2"
                      matTooltip="Export">
                <i class="fas fa-download" aria-hidden="true"></i>
              </button>
              <button mat-icon-button color="primary"
                      (click)="filters.toggle()"
                      matTooltip="Filter">
                <i class="fas fa-filter" aria-hidden="true"></i>
              </button>

            </div>
          </div>

          <div class="cm-card-content edge-to-edge">
            <cm-card-filters #filters>
              <mat-form-field class="col col-auto" floatLabel="never">
                <input title="name" type="text" matInput
                       [value]="filter.name"
                       [formControl]="filter.nameControl"
                       placeholder="Ad unit name"/>
              </mat-form-field>

              <mat-form-field class="col col-auto" floatLabel="never">
                <mat-select placeholder="Filter by publisher"
                            [(ngModel)]="filter.publisherId"
                            (selectionChange)="filterData()">
                  <mat-option>All publishers</mat-option>
                  <mat-option *ngFor="let publisher of availablePublishers" [value]="publisher.id">
                    {{publisher.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="col col-auto" floatLabel="never">
                <mat-select placeholder="Status"
                            multiple
                            #status
                            [(ngModel)]="filter.selectedStatuses">
                  <mat-option *ngFor="let status of statusesKL" [value]="status.key">{{status.label}}</mat-option>
                </mat-select>
              </mat-form-field>

             <div class="col col-auto d-flex">
               <button mat-raised-button color="primary"
                       (click)="refreshData(); filters.toggle()">
                 Apply filter
               </button>
               <button mat-raised-button color="primary" class="ml-1"
                       (click)="filter.resetFilter()">
                 Reset filter
               </button>
             </div>


            </cm-card-filters>

            <div class="card-message" *ngIf="showLoadingData">
              <mat-spinner  [color]="'primary'" [mode]="'indeterminate'"
                           [diameter]="'30'"></mat-spinner>
            </div>


            <div class="table-scroll-wrapper">
              <mat-table #table [dataSource]="dataSource" [hidden]="showLoadingData" matSort matSortActive="createdOn"
                         matSortDirection="desc">

                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <mat-header-cell *matHeaderCellDef class="d-none d-md-flex">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                  [checked]="selection.hasValue() && isAllSelected()"
                                  [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="d-none d-md-flex">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(row) : null"
                                  [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="bridgeAdUnitName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <!--<span class="mobile-label">Name:</span>-->
                    <cm-device-placement-icon [placement]="element.devicePlacement"></cm-device-placement-icon>
                    {{element.bridgeAdUnitName}}
                    <span class="badge badge-default ml-1" *ngIf="element.bidder" title="Bidder unit">BDR</span>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="publisherName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Publisher</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Publisher:</span>
                    <span class="text-truncate" title="{{element.publisherName}}">{{element.publisherName}}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="sites">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Sites</mat-header-cell>
                  <mat-cell *matCellDef="let element" style="overflow: visible">
                    <span class="mobile-label">Sites:</span>
                    <span class="mr-2" *ngIf="isIndexOrSovrn" matTooltip="Site is active">
                      <i class="far fa-check text-success">
                      </i>
                    </span>
                    <span class="mr-2" *ngIf="!isIndexOrSovrn">
                      <i class="fas fa-circle text-success" title="Site approved for another unit"
                         *ngIf="element.siteApprovedForAnotherUnit" aria-hidden="true"></i>
                    </span>
                    <!--<cm-simple-list-preview-popover [list]="element._domainUrls"></cm-simple-list-preview-popover>-->
                    <cm-popover-list [list]="element._domainUrls"></cm-popover-list>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Status:</span>
                    <mat-select placeholder="Status" [(ngModel)]="element.status">
                      <mat-option *ngFor="let status of statusesKL" [value]="status.key">
                        {{ status.label }}
                      </mat-option>
                    </mat-select>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="hbId">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>HB id</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">HB id:</span>
                    <mat-form-field class="w-100">
                      <input matInput [(ngModel)]="element.hbId">
                    </mat-form-field>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="siteId">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Site id</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Site id:</span>
                    <mat-form-field class="w-100">
                      <input matInput [(ngModel)]="element.siteId">
                    </mat-form-field>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="adstxtStatus">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Ads.txt</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="d-flex justify-content-center">
                    <span class="mobile-label">Ads.txt</span>
                    <span matTooltip="Ads.txt is valid">
                      <i class="far fa-check text-success"></i>
                    </span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="createdOn">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Created on</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Created on:</span>
                    {{element.createdOn | date: 'yyyy-MM-dd'}}
                    <small class="d-block">{{element.createdOn | date: 'hh:mm a'}}</small>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="unitActivated">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Unit activated</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="mat-cell--has-sort">
                    <span class="mobile-label">Unit activated:</span>
                    <mat-checkbox
                      [(ngModel)]="element.unitActivated">
                    </mat-checkbox>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef mat-sort-header
                                   class="d-flex justify-content-end">
                    Actions
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span class="mobile-label">Actions:</span>
                    <button class=""
                            mat-icon-button
                            color="primary"
                            *ngIf="element.ronSiteList" (click)="downloadRonSiteList(element)"
                            matTooltip="Download RON site list">
                      <i class="fas fa-paperclip" aria-hidden="true"></i>
                    </button>
                    <a href="{{getUrl(element)}}/ads.txt" target="_blank"
                       class="mat-icon-button mat-primary"
                       matTooltip="Ads.txt">
                      <i class="far fa-file-alt" aria-hidden="true"></i>
                    </a>
                    <button mat-icon-button
                            color="primary"
                            (click)="openCommentDialog(element)"
                            matTooltip="Comment">
                      <i class="fas fa-comment" aria-hidden="true"></i>
                    </button>
                  </mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="columns"></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: columns;"></mat-row>
              </mat-table>
            </div>

          </div>

          <div class="cm-card-footer" [hidden]="showLoadingData">
            <mat-paginator #paginator
                           [pageSize]="10"
                           [pageSizeOptions]="[5, 10, 20]">
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
